import React from 'react';
import { PageLayout } from './PageLayout';
import { Mail, Clock, MessageSquare, AlertCircle } from 'lucide-react';

export const ContactPage = () => {
    return (
        <PageLayout title="Kontakt">
            <div className="space-y-12">
                {/* Intro */}
                <section>
                    <p className="text-muted-foreground leading-relaxed">
                        Haben Sie Fragen, Anregungen oder Feedback? Wir freuen uns über Ihre Nachricht!
                        Unser Team ist bemüht, alle Anfragen so schnell wie möglich zu beantworten.
                    </p>
                </section>

                {/* Contact Info */}
                <section>
                    <h2 className="text-2xl font-semibold text-foreground mb-6">
                        So erreichen Sie uns
                    </h2>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {/* Email */}
                        <div className="bg-secondary/50 rounded-lg p-6">
                            <div className="flex items-center gap-3 mb-4">
                                <div className="p-3 bg-primary/10 rounded-lg">
                                    <Mail className="h-6 w-6 text-primary" />
                                </div>
                                <div>
                                    <h3 className="font-semibold text-foreground">E-Mail</h3>
                                    <p className="text-sm text-muted-foreground">Bevorzugter Kontaktweg</p>
                                </div>
                            </div>
                            <a 
                                href="mailto:info@detoxteetest.com"
                                className="text-primary hover:underline font-medium"
                            >
                                info@detoxteetest.com
                            </a>
                        </div>

                        {/* Response Time */}
                        <div className="bg-secondary/50 rounded-lg p-6">
                            <div className="flex items-center gap-3 mb-4">
                                <div className="p-3 bg-primary/10 rounded-lg">
                                    <Clock className="h-6 w-6 text-primary" />
                                </div>
                                <div>
                                    <h3 className="font-semibold text-foreground">Antwortzeit</h3>
                                    <p className="text-sm text-muted-foreground">Wir bemühen uns</p>
                                </div>
                            </div>
                            <p className="text-foreground">
                                In der Regel innerhalb von 24-48 Stunden (werktags)
                            </p>
                        </div>
                    </div>
                </section>

                {/* Topics */}
                <section>
                    <h2 className="text-2xl font-semibold text-foreground mb-6">
                        Wobei können wir helfen?
                    </h2>
                    
                    <div className="space-y-4">
                        <div className="flex items-start gap-4 p-4 bg-card border border-border rounded-lg">
                            <MessageSquare className="h-5 w-5 text-primary mt-1 flex-shrink-0" />
                            <div>
                                <h3 className="font-medium text-foreground mb-1">
                                    Allgemeine Anfragen
                                </h3>
                                <p className="text-sm text-muted-foreground">
                                    Fragen zu unseren Vergleichen, Bewertungskriterien oder unserer 
                                    Arbeitsweise.
                                </p>
                            </div>
                        </div>

                        <div className="flex items-start gap-4 p-4 bg-card border border-border rounded-lg">
                            <MessageSquare className="h-5 w-5 text-primary mt-1 flex-shrink-0" />
                            <div>
                                <h3 className="font-medium text-foreground mb-1">
                                    Produktvorschläge
                                </h3>
                                <p className="text-sm text-muted-foreground">
                                    Sie möchten, dass wir ein bestimmtes Produkt in unseren Vergleich 
                                    aufnehmen? Lassen Sie es uns wissen!
                                </p>
                            </div>
                        </div>

                        <div className="flex items-start gap-4 p-4 bg-card border border-border rounded-lg">
                            <MessageSquare className="h-5 w-5 text-primary mt-1 flex-shrink-0" />
                            <div>
                                <h3 className="font-medium text-foreground mb-1">
                                    Fehler melden
                                </h3>
                                <p className="text-sm text-muted-foreground">
                                    Sie haben einen Fehler auf unserer Website oder in unseren 
                                    Produktinformationen gefunden? Wir freuen uns über Ihre Meldung.
                                </p>
                            </div>
                        </div>

                        <div className="flex items-start gap-4 p-4 bg-card border border-border rounded-lg">
                            <MessageSquare className="h-5 w-5 text-primary mt-1 flex-shrink-0" />
                            <div>
                                <h3 className="font-medium text-foreground mb-1">
                                    Kooperationsanfragen
                                </h3>
                                <p className="text-sm text-muted-foreground">
                                    Sie sind Hersteller oder Händler und möchten mit uns zusammenarbeiten? 
                                    Kontaktieren Sie uns für weitere Informationen.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Note */}
                <section className="bg-amber-50 border border-amber-200 rounded-lg p-6">
                    <div className="flex items-start gap-3">
                        <AlertCircle className="h-5 w-5 text-amber-600 mt-0.5 flex-shrink-0" />
                        <div>
                            <h3 className="font-semibold text-amber-800 mb-2">Bitte beachten Sie</h3>
                            <p className="text-sm text-amber-700">
                                Wir können keine medizinischen Fragen beantworten oder individuelle 
                                Produktempfehlungen geben. Bei gesundheitlichen Fragen wenden Sie sich 
                                bitte an einen Arzt oder Apotheker. Für Fragen zu Bestellungen wenden 
                                Sie sich bitte direkt an den jeweiligen Händler.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Address */}
                <section>
                    <h2 className="text-2xl font-semibold text-foreground mb-4">
                        Anschrift
                    </h2>
                    <address className="not-italic text-muted-foreground">
                        DetoxTeeTest.com<br />
                        Friedrichstraße 147<br />
                        10117 Berlin<br />
                        Deutschland
                    </address>
                </section>
            </div>
        </PageLayout>
    );
};

